import { useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthContainer from "../components/AuthContainer/AuthContainer";
import Button from "../components/Button/Button";
import GridLGHidden from "../components/GridComponent/components/GridLGHidden";
import GridSMHidden from "../components/GridComponent/components/GridSMHidden";
import Header from "../components/Header/Header";
import Typography from "../components/Typography/Typography";
import BlueLogo from "../assets/icons/logo-text.svg";
import CalendarIcon from "../assets/icons/bx-calendar-blue.svg";
import { logCustomEvent } from "../utils/analytics";
import { openCalendlyConsultation } from "../utils/calendly";

const trackProdEvent = (eventName: string) => {
  if (process.env.REACT_APP_ENV === "prod") {
    logCustomEvent(eventName);
  }
};

const GetStarted = () => {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    metaThemeColor && metaThemeColor.setAttribute("content", "#fbfbfe");
  }, []);

  const goToCheckout = () => {
    trackProdEvent("BusinessPurchaseLicenses(WEB)Prod");
    navigate("/checkout");
  };

  return (
    <AuthContainer>
      <div className="lg:rounded-20 flex h-svh w-full flex-col bg-[#FBFBFE] lg:h-auto lg:w-[522px] lg:bg-white lg:p-24">
        <GridLGHidden>
          <Header backgroundColor="[#FBFBFE]" />
        </GridLGHidden>
        <GridSMHidden className="flex justify-center">
          <img src={BlueLogo} alt="" width={106} height={32} />
        </GridSMHidden>

        <div className="flex flex-1 flex-col justify-center px-12 lg:mt-48 lg:flex-none lg:px-0">
          <Typography
            as="h1"
            type="Header2"
            className="mb-12 text-center !font-semibold"
          >
            Talkpal for organizations
          </Typography>
          <Typography
            type="Body2"
            className="text-center !text-[#868686] lg:px-12"
          >
            You have the option to schedule a demo session, where you can dive
            deeper into the various features we offer, or you can choose to
            purchase licenses right away.
          </Typography>
        </div>

        <div className="flex w-full flex-col gap-12 px-12 pb-24 lg:mt-48 lg:px-0 lg:pb-0">
          <Button
            buttonType="secondary"
            title="Book a free consultation"
            testID="book-consultation"
            icon={<img src={CalendarIcon} alt="" width={24} height={24} />}
            onClick={() => {
              trackProdEvent("BusinessConsultationOpen(WEB)Prod");
              openCalendlyConsultation();
            }}
          />
          <Button
            buttonType="primary"
            title="Purchase licenses"
            testID="purchase-licenses"
            onClick={goToCheckout}
          />
        </div>
      </div>
    </AuthContainer>
  );
};

export default GetStarted;
